import React, { useEffect } from 'react';
import { Button } from '@superops/ui-design-system';
import { withErrorBoundary, useSuperListHook } from '@nile/components';
import { FormattedMessage } from 'react-intl';
import { isEqual } from 'lodash';

const ResetFilter = ({
  tableName,
  viewId,
  className,
  showOnlyOnTableFilter,
  showOnlyOnAdvancedFilter,
  resetToDefaultAdvanceFilter,
  defaultAdvanceFilter
}) => {
  const {
    showResetFilter,
    resetFilters,
    advanceFilterCondition
  } = useSuperListHook({
    viewId,
    tableName,
    showOnlyOnTableFilter,
    showOnlyOnAdvancedFilter,
    resetToDefaultAdvanceFilter,
    defaultAdvanceFilter
  });

  const classNames = ['flex actr jctr', className].filter(Boolean).join(' ');

  return (
    <>
      {showResetFilter && (
        <div className={classNames}>
          <Button id="resetSuperListFilter" plain onClick={resetFilters}>
            <FormattedMessage id="ticket.details.resetFilters" />
          </Button>
        </div>
      )}
    </>
  );
};

export default withErrorBoundary(ResetFilter);
